module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-shadow-12.9844782d.png";